import type { ScannerPage } from './lib'

export async function exportScannedPdf(pages: ScannerPage[], signal?: AbortSignal): Promise<Blob> {
  if (typeof Worker === 'undefined' || typeof OffscreenCanvas === 'undefined' || typeof createImageBitmap === 'undefined') {
    throw new Error('unsupported-browser')
  }
  const worker = new Worker(new URL('./scanner.worker.ts', import.meta.url), { type: 'module' })
  return await new Promise<Blob>((resolve, reject) => {
    const cancel = () => { worker.terminate(); reject(new DOMException('Cancelled', 'AbortError')) }
    if (signal?.aborted) {
      cancel()
      return
    }
    signal?.addEventListener('abort', cancel, { once: true })
    worker.onerror = () => { signal?.removeEventListener('abort', cancel); worker.terminate(); reject(new Error('Worker failed')) }
    worker.onmessage = (event: MessageEvent<{ id: number; bytes?: Uint8Array; error?: string }>) => {
      signal?.removeEventListener('abort', cancel)
      worker.terminate()
      if (event.data.error || !event.data.bytes) reject(new Error(event.data.error ?? 'Empty output'))
      else resolve(new Blob([event.data.bytes], { type: 'application/pdf' }))
    }
    worker.postMessage({ id: 1, pages: pages.map(({ file, width, height, transform }) => ({ file, width, height, transform })) })
  })
}
